import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  eduDataService
} from 'app/services';
import { alerts } from 'app/components/global';
import editDocumentDialog from './editDocumentDialog';
import editWebinarDialog from './editWebinarDialog';
import editPresentationDialog from './editPresentationDialog';
import controller from './edit-media-dialog.controller';
import template from './edit-media-dialog.html';
import nameMessagesTpl from './name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    topic = null,
    section = null,
    media = null
  }) {
    return {
      controller,
      controllerAs: 'editTrainingMediaDialogVM',
      locals: {
        topic,
        section,
        media
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.trainingAdministration.media.editMediaDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  eduDataService,
  copy,
  alerts,
  editDocumentDialog,
  editWebinarDialog,
  editPresentationDialog
])
  .service('trainingAdminEditMediaDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.admin.trainingAdministration.media.editMediaDialog created');
